import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import i18next from '../lang';

interface InfiniteScrollFooterProps {
  loadedCount: number;
  totalCount: number;
  isLoading: boolean;
  hasMore: boolean;
  sentinelRef: React.RefCallback<HTMLDivElement>;
}

const InfiniteScrollFooter: React.FC<InfiniteScrollFooterProps> = ({
  loadedCount,
  totalCount,
  isLoading,
  hasMore,
  sentinelRef,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2, gap: 1 }}>
      {!isLoading && loadedCount === 0 && totalCount === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {i18next.t('common.no_search_results')}
        </Typography>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {i18next.t('common.showing_items', { loaded: loadedCount, total: totalCount })}
        </Typography>
      )}
      {isLoading && <CircularProgress size={24} />}
      {hasMore && <div ref={sentinelRef} style={{ height: 1 }} />}
    </Box>
  );
};

export default InfiniteScrollFooter;
